import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Step, StepLabel, Stepper, Typography, Divider } from '@material-ui/core'
import { Page, Header, CustomButton } from 'components'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import SaveIcon from '@material-ui/icons/Save'
import useRouter from 'utils/useRouter'
import { DescricoesVestigiosExame } from 'components/DescricoesVestigiosExame'
import { AnaliseConstatacao } from './AnaliseConstatacao'
import { useExameConstatacao } from './useExameConstatacao'
import useStyles from './ExameConstatacao.styles'

export const ExameConstatacao = (props) => {
  const { route } = props
  const classes = useStyles()
  const router = useRouter()

  const { params, exameRealizado, activeStep, processandoAlteracaoRespostas, handleEtapaAnterior, handleProximaEtapa } = useExameConstatacao()

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={`Exame de Constatação ${exameRealizado?.numeroExame || ''}`} overline={route.secao} />

      <div className={classes.formContainer}>
        <div className={classes.stepperContainer}>
          <Stepper alternativeLabel activeStep={activeStep} className={classes.stepper}>
            <Step key="Descrições técnicas dos vestígios" className={classes.step}>
              <StepLabel>Descrições técnicas dos vestígios</StepLabel>
            </Step>
            <Step key="Análises dos vestígios" className={classes.step}>
              <StepLabel>Análises dos vestígios</StepLabel>
            </Step>
          </Stepper>
        </div>

        <Grid container justifyContent="space-between" spacing={3} className={classes.contentSplitter}>
          <Grid item xs={12} className={classes.downContainer}>
            <Grid container justifyContent="space-between" spacing={1}>
              <Grid item xs={12}>
                {activeStep === 0 && (
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography component="h5" variant="h5">
                        DESCRIÇÕES TÉCNICAS DOS VESTÍGIOS
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider className={classes.divider} />
                    </Grid>
                    <Grid item xs={12}>
                      <DescricoesVestigiosExame idExameSolicitado={params.idExameSolicitado} idExameRealizado={params.idExameRealizado} />
                    </Grid>
                  </Grid>
                )}

                {activeStep === 1 && (
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography component="h5" variant="h5">
                        ANÁLISES DOS VESTÍGIOS
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider className={classes.divider} />
                    </Grid>
                    <Grid item xs={12}>
                      <AnaliseConstatacao idExameSolicitado={params.idExameSolicitado} idExameRealizado={params.idExameRealizado} />
                    </Grid>
                  </Grid>
                )}
              </Grid>

              <Grid item xs={12}>
                <Divider />
              </Grid>

              {/* Rodapé de botões */}
              <Grid item xs={12}>
                <Grid container justify="space-between" spacing={1} className={classes.buttons}>
                  <Grid item>
                    {activeStep === 0 ? (
                      <CustomButton variant="outlined" colorType="primary" onClick={() => router.history.goBack()} startIcon={<ArrowBackIcon />}>
                        Voltar
                      </CustomButton>
                    ) : (
                      <CustomButton variant="outlined" colorType="primary" onClick={handleEtapaAnterior} disabled={processandoAlteracaoRespostas} startIcon={<NavigateBeforeIcon />}>
                        Etapa Anterior
                      </CustomButton>
                    )}
                  </Grid>
                  <Grid item>
                    <CustomButton variant="contained" colorType="primary" onClick={handleProximaEtapa} isLoading={processandoAlteracaoRespostas} startIcon={activeStep === 1 ? <SaveIcon /> : <NavigateNextIcon />}>
                      {activeStep === 1 ? 'Finalizar formulário' : 'Próxima Etapa'}
                    </CustomButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Page>
  )
}

ExameConstatacao.propTypes = {
  route: PropTypes.shape({
    titulo: PropTypes.string,
    secao: PropTypes.string,
  }).isRequired,
}
